import { EntityActionFactory, EntityOp } from '@ngrx/data';
import { GrupoEspecie } from './grupos-especie.model';

const entityActionFactory = new EntityActionFactory();

export const entityGrupoEspecieLoadRequest =
  entityActionFactory.create<GrupoEspecie>('GrupoEspecie', EntityOp.QUERY_ALL);

export const entityGrupoEspecieAddRequest = (gE: GrupoEspecie) =>
  entityActionFactory.create<GrupoEspecie>(
    'GrupoEspecie',
    EntityOp.SAVE_ADD_ONE,
    gE
  );